import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import React from "react";
import Immutable, { Map } from "immutable";
import tableau from "exports-loader?tableau!../vendor/tableau-2.8.0.min.js";

import TableauActions from "../actions/TableauActions";
import { View } from "../stores/ReportStore";

export default class TableauViz extends React.Component {
  static defaultProps = {
    filters: Map(),
    parameters: Map(),
  };

  constructor(props) {
    super(props);
    this.state = {
      viz: null,
      loading: true,
      ticket: null,
      prevFilters: Map(),
      prevParameters: Map(),
    };
  }

  requestNewTicket() {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    TableauActions.retrieveTicket(this.props.orgId).then((ticket) => {
      this.setState({ ticket: ticket });
    });
  }

  componentDidMount() {
    this.requestNewTicket();
  }

  static getDerivedStateFromProps(props, state) {
    // If path, org filter, or tableau options change, we need to re-render the report. Let's
    // do this by canceling the ticket.
    if (
      props.view.reportPath() !== state.prevReportPath ||
      props.orgId !== state.prevOrgId ||
      !Immutable.is(props.filters, state.prevFilters) ||
      !Immutable.is(props.parameters, state.prevParameters)
    ) {
      return {
        prevReportPath: props.view.reportPath(),
        prevOrgId: props.orgId,
        prevFilters: props.filters,
        prevParameters: props.parameters,
        ticket: null,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.ticket) {
      if (this.state.viz !== null) {
        this.state.viz.dispose();
        this.state.viz = null;
      }
      this.requestNewTicket();
    }

    // If we have a new ticket, create a new viewer
    if (this.state.ticket && this.state.ticket !== prevState.ticket) {
      if (this.state.viz !== null) {
        this.state.viz.dispose();
        this.state.viz = null;
      }
      this.createTableau();
    }

    // If we have a viewer and the view has changed, activate it
    if (this.state.viz && this.props.view.id !== prevProps.view.id) {
      try {
        this.state.viz.getWorkbook().activateSheetAsync(this.props.view.name);
      } catch (err) {
        if (err.tableauSoftwareErrorCode === "sheetNotInWorkbook") {
          console.warn("Detected invalid sheet. Requesting new ticket...");
        } else {
          console.error(err);
        }
        this.requestNewTicket();
      }
    }
  }

  _updateParameters = () => {
    const wb = this.state.viz.getWorkbook();
    this.props.parameters.forEach((paramValue, paramKey) => {
      console.log(`Setting param ${paramKey} = ${paramValue}`);
      wb.changeParameterValueAsync(paramKey, paramValue);
    });
  };

  _vizSizeKnown = () => {
    this.setState({ loading: false });
  };

  createTableau() {
    const div = this.viz;
    const { parameters } = this.props;
    const district = parameters?.get('Select Geography')
    const defaultOptions = {
      hideTabs: true,
      hideToolbars: true,
      // TODO: we should really make this correctly detect, but right now this is causing
      // DCCC reports to render improperly
      device: "desktop",
      onFirstInteractive: this._updateParameters,
      onFirstVizSizeKnown: this._vizSizeKnown,
      // "Select CD": district || ""
    };

    const options = Object.assign(
      defaultOptions,
      this.props.tableauOptions || {},
      (this.props.filters || Map()).toJS()
    );
    const tableauViz = new tableau.Viz(
      div,
      this.props.view.url(this.state.ticket),
      options
    );
    this.setState({ viz: tableauViz });

    return tableauViz;
  }

  componentWillUnmount() {
    if (this.state.viz !== null) {
      this.state.viz.dispose();
    }
  }

  render() {
    return (
      <div
        ref={(viz) => {
          this.viz = viz;
        }}
      >
        {this.state.loading && (
          <div
            style={{
              textAlign: "center",
              height: "50vw",
            }}
          >
            Loading visualization...
          </div>
        )}
      </div>
    );
  }
}

TableauViz.propTypes = {
  view: PropTypes.instanceOf(View).isRequired,
  orgId: PropTypes.string,
  tableauOptions: PropTypes.object,
  filters: ImmutablePropTypes.map,
  parameters: ImmutablePropTypes.map,
};
